'use strict';

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        // chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' + response.message + '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
            $('.minicart').trigger('focusout');
        }, 5000);
    }
}

$('body').on('click', '.add-to-bag:not(.disabled)', function (e) {
    e.preventDefault();
    var baseURL = $(this).attr('data-action');
    var pid = $(this).attr('data-pid');
    var src = 'step-product';
    var url = baseURL + '?pids=' + pid + '&src=' + src;
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            if (!data.error) {
                handlePostCartAdd(data);
                $('body').trigger('product:afterAddToCart', data);
            } else {
                var errMsg = data.message;
                console.log(errMsg);
            }
            $.spinner().stop();
        },
        error: function (err) {
            $.spinner().stop();
            console.log(err);
        }
    });
});

$('body').on('click', '.add-all-to-bag', function (e) {
    e.preventDefault();
    var baseURL = $(this).attr('data-action');
    var pidDataSet = document.querySelectorAll('.slick-slide:not(.slick-cloned) .step-action .add-to-bag:not(.disabled)');
    var pids = '';
    pidDataSet.forEach((productId) => {
        pids += productId.dataset.pid + ',';
    });
    pids = pids.slice(0, -1);
    var src = 'step-product';
    var url = baseURL + '?pids=' + pids + '&src=' + src;
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            if (!data.error) {
                handlePostCartAdd(data);
                $('body').trigger('product:afterAddToCart', data);
            } else {
                var errMsg = data.message;
                console.log(errMsg);
            }
            $.spinner().stop();
        },
        error: function (err) {
            $.spinner().stop();
            console.log(err);
        }
    });
});
